import { Box, Button, IconButton, Image, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { InstructionsProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import Slider from 'react-slick';
import Move from '../assets/images/Instructions/Move.png';
import Tap from '../assets/images/Instructions/Tap.png';
import Export from '../assets/images/Instructions/Export.png';
import ExportAR from '../assets/images/Instructions/ExportAR.png';
import FourIngredients from '../assets/images/Instructions/FourIngredients.png';
import FourIngredientsAR from '../assets/images/Instructions/FourIngredientsAR.png';
import MenuSwitch from '../assets/images/Instructions/MenuSwitch.png';
import MenuSwitchAR from '../assets/images/Instructions/MenuSwitchAR.png';
import IconClick from '../assets/images/Instructions/IconClick.png';
import { Eclipse } from '../Icons/Eclipse';
import { InstructionsLeftArrow } from '../Icons/InstructionsLeftArrow';
import { InstructionsRightArrow } from '../Icons/InstructionsRightArrow';

export interface InstructionImages {
  text: string;
  textAR: string;
  image: string;
}

const Instructions = ({ activeLocale, active, setActive }: InstructionsProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [slider, setSlider] = useState<any>();
  const [activeImageIndex, setActiveImageIndex] = useState({ oldIndex: 0, newIndex: 0 });

  const Images: InstructionImages[] = [
    {
      text: 'Hold and drag to explore your surroundings',
      textAR: 'امسك واسحب لاستكشاف محيطك',
      image: Move,
    },
    {
      text: 'Tap on the floor to move',
      textAR: 'اضغط على الأرض للتحرك',
      image: Tap,
    },
    {
      text: 'Click on the icons to discover more',
      textAR: 'انقر فوق الرموز لاكتشاف المزيد',
      image: IconClick,
    },
    {
      text: 'Go to menu to switch between the worlds',
      textAR: 'اذهب إلى القائمة للإنتقال من عالم إلى آخر',
      image: activeLocale.includes('ar') ? MenuSwitchAR : MenuSwitch,
    },
    {
      text: 'Collect 4 ingredients  across 4 worlds...',
      textAR: 'اجمع 4 مكونات من كل عالم',
      image: activeLocale.includes('ar') ? FourIngredientsAR : FourIngredients,
    },
    {
      text: '... And become a L’Occitane expert!',
      textAR: 'وستصبح خبير في لوكسيتان',
      image: activeLocale.includes('ar') ? ExportAR : Export,
    },
  ];

  const nextSlide = () => {
    slider.slickNext();
  };

  const prevSlide = () => {
    slider.slickPrev();
  };

  const settings = {
    speed: 500,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setActiveImageIndex({ oldIndex: oldIndex, newIndex: newIndex });
    },
  };
  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.1)"
        transition="all 1s"
        zIndex={4}
        onClick={() => {
          setActive();
          setTimeout(() => {
            setActiveImageIndex({ oldIndex: 0, newIndex: 0 });
            slider.slickGoTo(0);
          }, 500);
        }}
      />

      <Box
        zIndex={5}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '25px', '25px', '25px']}
        width={['95vw', '350px', '450px', '450px', '450px']}
        height={['380px', '460px', '550px', '550px', '550px']}
      >
        <LoccitaneClose
          boxSize={[4, 6, 8]}
          position="absolute"
          top={['10px', '20px', '25px']}
          left={['10px', '20px', '25px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
            setTimeout(() => {
              setActiveImageIndex({ oldIndex: 0, newIndex: 0 });
              slider.slickGoTo(0);
            }, 500);
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ filter: 'drop-shadow(-2px 0px 2px #FFF736) drop-shadow(2px 0px 4px #FFCB00)', stroke: 'black' }}
          transition=".5s"
        />

        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
          alignItems="center"
          height="100%"
        >
          <Box
            width={['210px', '250px', '320px', '320px', '320px']}
            display="flex"
            flexDirection={['column', 'column', 'column', 'column', 'column']}
            position="relative"
          >
            <Box
              className="instructions-slider"
              width={['100%', '100%', '100%', '100%', '100%']}
              h={['auto', 'auto', 'auto', 'auto', 'auto']}
              textAlign="center"
            >
              <Slider ref={(slider) => setSlider(slider)} {...settings}>
                {Images?.map((image: InstructionImages, index: number) => (
                  <Image
                    key={index}
                    width={['auto', '100%', '400px', '100%', '100%']}
                    h={['auto', 'auto', 'auto', 'auto', 'auto']}
                    objectFit={['contain', 'contain', 'contain', 'contain', 'contain']}
                    src={image.image}
                  />
                ))}
              </Slider>
            </Box>
          </Box>
          <Box
            display={['flex', 'flex', 'flex', 'flex', 'flex']}
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            h="auto"
            mt={['-10px']}
          >
            {Images.map((image: InstructionImages, index: number) => (
              <Eclipse
                borderRadius="100%"
                key={image.image}
                m="0px 5px"
                boxSize={[2, 2, 3]}
                strokeWidth="2"
                stroke={activeImageIndex.newIndex === index ? '#FFD220' : '#D9D9D9'}
                fill={activeImageIndex.newIndex === index ? '#FFD220' : 'white'}
                onClick={() => {
                  slider.slickGoTo(index);
                }}
                cursor="pointer"
              />
            ))}
          </Box>
          <Text
            fontSize={['12px', '12px', '15px', '15px', '15px']}
            width={['100%', '100%', '100%', '100%', '100%']}
            textAlign="center"
            fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'RalewayMedium'}
          >
            {activeLocale.includes('ar')
              ? Images[activeImageIndex.newIndex].textAR
              : Images[activeImageIndex.newIndex].text}
          </Text>
          <Box
            w={['150px', '170px', '170px', '170px', '170px']}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <IconButton
              variant="outline"
              aria-label="Move Left"
              onClick={prevSlide}
              height={['30px', '40px', '40px', '40px', '40px']}
              width={['70px', '80px', '80px', '80px', '80px']}
              borderRadius="0px"
              icon={<InstructionsLeftArrow boxSize={[6, 8, 10]} />}
            />
            {activeImageIndex.newIndex === Images.length - 1 ? (
              <Button
                fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'RalewayMedium'}
                fontSize={['12px', '12px', '15px', '15px', '15px']}
                bg="#FFCB00"
                _hover={{ bg: 'rgb(255, 203, 0, 0.4)', _disabled: { bg: 'lightgrey', cursor: 'auto' } }}
                color="black"
                borderRadius="0px"
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                onClick={() => {
                  setActive();
                  setTimeout(() => {
                    setActiveImageIndex({ oldIndex: 0, newIndex: 0 });
                    slider.slickGoTo(0);
                  }, 500);
                }}
              >
                {activeLocale.includes('ar') ? 'تكملة' : 'GOT IT'}
              </Button>
            ) : (
              <IconButton
                variant="outline"
                aria-label="Move Left"
                onClick={nextSlide}
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                borderRadius="0px"
                icon={<InstructionsRightArrow boxSize={[6, 8, 10]} />}
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default Instructions;
